const api = {
  submitFixRequest: (controlNumber) => `/cubi-casa/${controlNumber}/fix-request`,
};

export { api };
